import { render, staticRenderFns } from "./msjModal.vue?vue&type=template&id=1f177d36&"
import script from "./msjModal.vue?vue&type=script&lang=js&"
export * from "./msjModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports